import Model from '@/lib/data/Model';

class PolicyType extends Model {
    static idProperty = 'id';

    fields = ['id', 'policy_type_name'];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [];
}

export default PolicyType;
